import { createRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useSession } from "@/auth/client";
import { WebDashboard } from "@/components/marketing/web-dashboard";
import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
import { Route as authenticatedRoute } from "../_authenticated";

function MarketingWebPage() {
  const { data: session } = useSession();
  // biome-ignore lint/suspicious/noExplicitAny: better-auth session role
  const isAdmin = (session?.user as any)?.role === "admin";
  const [syncing, setSyncing] = useState(false);
  const [nonce, setNonce] = useState(0);

  const handleSync = async () => {
    setSyncing(true);
    try {
      await fetch("/api/marketing-suite/sync/web", { method: "POST", credentials: "include" });
      setNonce((n) => n + 1);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Website Analytics"
        description="Traffic, engagement, and site health from Google Analytics, vs. benchmarks."
        actions={
          isAdmin ? (
            <Button variant="outline" size="sm" onClick={handleSync} disabled={syncing}>
              {syncing ? "Syncing…" : "Sync now"}
            </Button>
          ) : undefined
        }
      />
      <WebDashboard key={nonce} />
    </div>
  );
}

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/marketing/web",
  component: MarketingWebPage,
});
